
<template>
        <div class="row justify-content-center" :dir="language">
            <div class="col-lg-5 col-md-7" style="margin-top:12px;">
                <div class="card bg-secondary shadow border-0">
<!--                     <div class="card-header bg-transparent pb-5">
                        <div class="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div>
                        <div class="btn-wrapper text-center">
                            <a href="#" class="btn btn-neutral btn-icon">
                                <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                                <span class="btn-inner--text">Github</span>
                            </a>
                            <a href="#" class="btn btn-neutral btn-icon">
                                <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                                <span class="btn-inner--text">Google</span>
                            </a>
                        </div>
                    </div> -->

                    <div class="card-body px-lg-5 py-lg-5">
                        <div class="text-center mb-3">
                            <h2>{{texts.validateotp}}</h2>
                            <h4>{{texts.description}}</h4>
                        </div>
                         <div class="text-center mb-4">
                            <medium v-if="errors" style="color: red;">{{errors}}</medium>
                        </div>
                        <div class="text-center mb-4">
                            <medium v-if="localerrors" style="color: red;">{{localerrors}}</medium>
                        </div>
                          <form v-on:submit.prevent="onSubmit(otp);" style="text-align:center">
                            <fieldset class="form-group" style="text-align:center">
                                <base-input style="text-align:center"
                                            :placeholder="texts.otpcode"
                                            type="text"
                                            v-model="otp"
                                            >
                                </base-input>
                              </fieldset>

                            <div class="text-center">
                                <button v-if="!isLoading || errors" type="primary" class="btn btn-primary my-3 px-lg-8">{{texts.login}}</button>
                                <button v-if="isLoading" type="primary" class="btn btn-primary my-3 px-lg-8">Loading..</button>
                            </div>
                        </form>
                    </div>
                </div>
                <!-- <div class="row mt-3">
                    <div class="col-6">
                        <a href="#" class="text-light"><small>Forgot password?</small></a>
                    </div>
                    <div class="col-6 text-right">
                        <router-link to="/register" class="text-light"><small>Create new account</small></router-link>
                    </div>
                </div> -->
            </div>
        </div>
</template>
<script>
  import { mapState } from "vuex";
  import { VALIDATE_OTP } from "@/store/actions.type";
  import store from "@/store";
  import UserService from "@/common/user.service";

  export default {
    name: 'login',
    data() {
      return {
        texts : {
          validateotp : UserService.getLanguage() === "rtl" ? "التحقق من صحة الرمز" : "Validate OTP Code",
          description : UserService.getLanguage() === "rtl" ? "سوف تتلقى رمز التأكيد عن طريق البريد الإلكتروني" : "Please enter the code which you will receive by Email",
          otpcode : UserService.getLanguage() === "rtl" ? "الرمز" : "OTP Code",
          login : UserService.getLanguage() === "rtl" ? "تسجيل الدخول" : "Login"
        },
        language : UserService.getLanguage() || "ltr",
        email: '',
        password: '',
        isLoading: false,
        localerrors : null,
        emailBlured : false,
            valid : false

      }
    },
    methods: {
        validate : function(){
          this.emailBlured = true;
           if( this.validEmail(this.email)){
              this.valid = true;
           }
        },
        validEmail : function(email) {
            if (email !== '') {
                var re = /(.+)@(.+){2,}\.(.+){2,}/;
                return re.test(email.toLowerCase());
            }
            else {
                return true;
            }

        },
        onSubmit(otp) {
            if (otp !== '') {
                this.localerrors = "";

                Promise.all([
                  store.dispatch(VALIDATE_OTP, otp),

                ]).then((data) => {
                  console.log("WE IN HERE");
                  console.log(data[0]);
                  if (data[0]['errFlag'] == 0) {
                    this.isLoading = false;
                    if (data[0]['data']) {
                      if (data[0]['data']['reset']) {
                        if (Number(data[0]['data']['reset']) === 1) {
                          this.$router.push({ name: "resetpass" });
                        }
                      }
                    }
                    else {
                      if (data[0]['assignments'].length > 1) {
                        this.$router.push({ name: "assignments" });
                      }
                      //
                      else if (data[0]['assignments'].length === 0) {
                        this.$router.push({ name: "assignments" });
                      }
                      //
                      else {
                        console.log("PUSHING ROUTER TO OVERVIEW");
                        this.$router.push({ name: "overview" });
                      }
                    }

                  }
                  else if (data[0]['errFlag'] == 1){
                    this.$notify({
                            type: 'warning',
                            title: data[0]['errMsg']
                          });
                  }

                });
            }
            else {

              this.localerrors = "Email or Password cannot be empty !"

            }

          // this.$store
          //   .dispatch(LOGIN, { email, password })
          //   .then(() => this.$router.push({ name: "dashboard" }));
        }
    },
      computed: {

        ...mapState({
          errors: state => state.auth.errors
        })
      },
      mounted() {
        if (sessionStorage.getItem('reloaded') != null) {
        console.log('page was reloaded');
    } else {
        console.log('page was not reloaded');
    }

    sessionStorage.setItem('reloaded', 'yes');
         // Promise.all([
         //          store.dispatch(LOGOUT)
         //
         //        ]).then(() => {
         //
         //        });
      }
  };
</script>
<style>
</style>
